<div class="container-fluid well">
    <h5>{{title}}</h5>

    <div class="row">
        <div class="col-xs-8">
            <div class="input-group textarea-addon-fix">
                <span class="input-group-addon corner">
                    <i class="nlrp-icon nlrp-icon-edit corner-icon"></i>
                </span>
                <textarea
                    class="form-control"
                    name="generalComments"
                    id="generalComments"
                    placeholder="Enter general comments"
                    title="Enter a comment related to plan lodgement"
                    rows="4"
                    cols="50"
                    [maxlength]="255"
                    [disabled]="isDisabled()"
                    [(ngModel)]="getModel().generalComments">
                </textarea>
            </div>
        </div>
    </div>
</div>
